import React from "react"
import TabelaCadastroEdicaoPrecos from "../tabela-cadastro-edicao-precos"
import './cadastro-edicao-precos-lote.css'

export default function CadastroEdicaoPrecos() {
  return (
    <div className="page-cadastro-edicao-precos-lote">
      <TabelaCadastroEdicaoPrecos />
    </div>
  )
}